import { memo } from 'react';

import CheckIcon from '@material-ui/icons/Check';
import MinusIcon from 'components/icons/minus-icon';
import MuiCheckbox from '@material-ui/core/Checkbox';

import clsx from 'clsx';
import { useStyles } from './style';

interface Props {
  disabled?: boolean;
  onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
  checked?: boolean;
  name?: string;
  indeterminate?: boolean;
}

const Checkbox: React.FC<Props> = memo(
  ({ onChange, disabled, checked = false, indeterminate = false, ...rest }) => {
    const classes = useStyles();

    return (
      <MuiCheckbox
        classes={{
          root: classes.checkboxRoot,
          colorSecondary: classes.colorSecondary,
        }}
        onChange={onChange}
        checked={checked}
        disabled={disabled}
        icon={<span className={classes.checkboxIcon}></span>}
        checkedIcon={
          <span
            className={clsx(classes.checkboxIcon, classes.checkedCheckboxIcon)}
          >
            <CheckIcon className={classes.checkIcon} />
          </span>
        }
        indeterminate={indeterminate}
        indeterminateIcon={
          <span
            className={clsx(classes.checkboxIcon, classes.checkedCheckboxIcon)}
          >
            <MinusIcon className={classes.checkIcon} />
          </span>
        }
        {...rest}
      />
    );
  }
);

export default Checkbox;
